<template>
    <v-card class="mx-auto" tile elevation="0">
        <v-list dense>
            <v-subheader>
                <span class="text-subtitle-1 font-weight-bold">{{ event.toUpperCase() }}</span>
            </v-subheader>

            <v-list-item-group v-if="relevantLevels.length" color="primary">
                <v-list-group
                    v-for="level in relevantLevels"
                    :key="`${event}-${level.short}`"
                    :value="meet.is_international"
                >
                    <template #activator>
                        <v-list-item-title>
                            <div class="text-body-1">
                                <div class="d-flex">
                                    <div v-if="meet.is_international" class="mt-2">All</div>
                                    <div v-else class="mt-2">{{ level.label }}</div>
                                    <live-indicator v-if="isLive(level)" class="mt-3" />
                                </div>
                            </div>
                        </v-list-item-title>
                    </template>

                    <level-results
                        :event="proscoreEvent"
                        :meet="meet"
                        :level="level.short"
                        :live-result-category-ids="liveResultCategoryIds"
                    />
                </v-list-group>
            </v-list-item-group>
            <p v-else class="font-italic font-light ml-2 grey--text">No results to display...</p>
        </v-list>
    </v-card>
</template>

<script>
import get from 'lodash/get.js';
import ResultCategory from '@/Models/ResultCategory.js';
import levels from '@/levels.js';
import LevelResults from '@/Components/LevelResults.vue';
import LiveIndicator from '@/Components/LiveIndicator.vue';
import Meet from '@/Models/Meet.js';

export default {
    name: 'LevelsList',

    provide() {
        return {
            meetId: this.meetId,
        };
    },

    components: { LiveIndicator, LevelResults },

    props: {
        meetId: {
            type: Number,
            required: true,
        },

        resultCategoryIds: {
            type: Array,
            required: true,
        },

        liveResultCategoryIds: {
            type: Array,
            required: true,
        },

        event: {
            type: String,
            required: true,
        },
    },

    computed: {
        meet() {
            return Meet.find(this.meetId);
        },

        proscoreEvent() {
            return get(
                {
                    trampoline: 'TI',
                    'double-mini': 'DM',
                    tumbling: 'TU',
                    synchro: 'TS',
                    'all-around': 'AA',
                },
                this.event,
            );
        },

        eventLevels() {
            return ResultCategory.query()
                .where('event', this.proscoreEvent)
                .orderBy('level')
                .whereIdIn(this.resultCategoryIds)
                .get();
        },

        relevantLevels() {
            const results = _.groupBy(this.eventLevels, 'level');

            return levels.filter((level) => {
                if (['YE 11-12', 'YE 13-14'].includes(level.short) && Object.keys(results).includes('YE')) {
                    return true;
                }

                return Object.keys(results).includes(level.short);
            });
        },
    },

    methods: {
        isLive(level) {
            return _.some(
                this.eventLevels
                    .filter((resultCategory) => resultCategory.level === level.short)
                    .map((resultCategory) => {
                        return this.liveResultCategoryIds.includes(resultCategory.id);
                    }),
            );
        },
    },
};
</script>
